/**
 * Activity Log 관련 유틸리티 함수
 * 백엔드와 일치하도록 상수 파일에서 가져옴
 */
import {
  ACTIVITY_CATEGORY_LABELS,
  ACTIVITY_TYPE_LABELS,
  activityCategories,
  activityTypes,
} from '@/constants/activityLog';

/**
 * Activity Type에 따른 라벨 반환
 */
export const getActivityTypeLabel = (type: string): string => {
  return ACTIVITY_TYPE_LABELS[type] || type;
};

/**
 * Activity Category에 따른 라벨 반환
 */
export const getCategoryLabel = (category: string): string => {
  return ACTIVITY_CATEGORY_LABELS[category] || category;
};

export { activityTypes, activityCategories };

